export default __webpack_public_path__ + "static/media/scritta.d9cec2c6.svg";